// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__ny-1Z","consentsList":"PatientConsents_consentsList__3Drsq","consentsListEmpty":"PatientConsents_consentsListEmpty__2Kmod"};